import { c as _c } from "react/compiler-runtime";
import { LayoutContainer, Picture } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { ContentfulClick } from '@libs/analytics';
import { HeaderCtaTracker } from '../../../utils/HeaderCtaTracker';
import { getImageProps } from '../../../utils/propsImagesItems';
import { Text } from '../../Text';
import type { CampaignCarsUpProps } from '../types';
import { colorMap } from '../utils';
import './4up.scss';
export function CampaignCards4up(t0) {
  const $ = _c(31);
  const {
    header,
    body,
    cards,
    textLink,
    textLinkColor,
    textColor,
    backgroundFill,
    cardsTextColor
  } = t0;
  let t1;
  if ($[0] !== backgroundFill) {
    t1 = {
      background: backgroundFill
    };
    $[0] = backgroundFill;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== header || $[3] !== textColor) {
    t2 = <Text color={textColor} as="h2">{header}</Text>;
    $[2] = header;
    $[3] = textColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== body || $[6] !== textColor) {
    t3 = <Text align="center" color={textColor}>{body}</Text>;
    $[5] = body;
    $[6] = textColor;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== header || $[9] !== textLink || $[10] !== textLinkColor) {
    t4 = textLink && <HeaderCtaTracker textLink={textLink} linkTextColor={textLinkColor} header={header ?? ""} promoVariant="campaign cards up - 4up" promoType="campaign-cards-4up__card" />;
    $[8] = header;
    $[9] = textLink;
    $[10] = textLinkColor;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className="campaign-cards-4up__header">{t2}{t3}{t4}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== cards || $[17] !== cardsTextColor || $[18] !== header || $[19] !== textLink?.link?.webUrl) {
    let t7;
    if ($[21] !== cardsTextColor || $[22] !== header || $[23] !== textLink?.link?.webUrl) {
      t7 = (c, index) => {
        const cm = colorMap[cardsTextColor];
        const linkUrl = c?.link?.webUrl || textLink?.link?.webUrl || "";
        const Component = linkUrl ? "a" : "div";
        return <ContentfulClick component={Component} key={c.sysId} className="campaign-cards-4up__card" style={{
          background: c.backgroundFill
        }} href={linkUrl} eventData={{
          position: index + 1,
          linkText: cn(c.preheader, c.header, c.subheader, c.body),
          linkUrl,
          promoTitle: header ?? "",
          promoVariant: "campaign cards up - 4up",
          promoDesc: c.internalTitle,
          promoType: "campaign-cards-4up__card"
        }}><div className="campaign-cards-4up__card-content"><Text color={cm?.preheaderColor} className="campaign-cards-4up__card-preheader">{c.preheader}</Text><div className="campaign-cards-4up__card-heading-raw"><Text as="h2" color={cm?.headingColor}>{c.header}</Text><Text color={cm?.subheaderColor} className="campaign-cards-4up__card-subheader">{c.subheader}</Text></div><Text color={cm?.textColor} className="campaign-cards-4up__card-body">{c.body}</Text><Text color={cm?.textColor} className="campaign-cards-4up__card-terms">{c.terms}</Text></div><Picture {...getImageProps(c.image)} /></ContentfulClick>;
      };
      $[21] = cardsTextColor;
      $[22] = header;
      $[23] = textLink?.link?.webUrl;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    t6 = cards.slice(0, 4).map(t7);
    $[16] = cards;
    $[17] = cardsTextColor;
    $[18] = header;
    $[19] = textLink?.link?.webUrl;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[25] !== t6) {
    t7 = <div className="campaign-cards-4up__cards">{t6}</div>;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t1 || $[28] !== t5 || $[29] !== t7) {
    t8 = <LayoutContainer className="campaign-cards-4up"><div className="campaign-cards-4up__content" style={t1}>{t5}{t7}</div></LayoutContainer>;
    $[27] = t1;
    $[28] = t5;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}